import type { ReactNode } from "react";
import { RevealOnScroll } from "./RevealOnScroll";

type Props = {
  meta: string;
  title: string;
  body: ReactNode;
  statValue: string;
  statLabel: ReactNode;
};

export function SingleCase({ meta, title, body, statValue, statLabel }: Props) {
  return (
    <RevealOnScroll>
      <div className="grid gap-10 rounded-lg border border-rule bg-white p-8 md:grid-cols-[1.4fr_1fr] md:p-12">
        <div>
          <div className="font-mono text-[11px] uppercase tracking-[0.18em] text-ink-4">
            {meta}
          </div>
          <h3 className="mt-4 font-display text-2xl leading-snug text-ink md:text-3xl">
            {title}
          </h3>
          <div className="mt-5 space-y-4 leading-relaxed text-ink-3">{body}</div>
        </div>
        <div className="flex flex-col justify-center rounded-md bg-cyan-tint p-8 text-center">
          <div className="font-display text-5xl text-cyan-deep md:text-6xl">
            {statValue}
          </div>
          <div className="mt-3 font-mono text-[11px] uppercase tracking-wider text-ink-3">
            {statLabel}
          </div>
        </div>
      </div>
    </RevealOnScroll>
  );
}
